/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, filterUser } = {}) {
    const params = [];
    if (searchKey) params.push(`search=${searchKey}`);
    if (filterUser) params.push('filter_user=true');
    const query = params.length ? `?${params.join('&')}` : '';
    return axios.get(`${this.url}${query}`);
  }

  createWithFiles(data) {
    const formData = new FormData();
    formData.append('canned_response[short_code]', data.short_code);
    formData.append('canned_response[content]', data.content);
    if (data.user_id) {
      formData.append('canned_response[user_id]', data.user_id);
    } else {
      formData.append('canned_response[user_id]', '');
    }
    if (data.files && data.files.length) {
      data.files.forEach(file => {
        formData.append('canned_response[files][]', file);
      });
    }
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateWithFiles(id, data) {
    const formData = new FormData();
    formData.append('canned_response[short_code]', data.short_code);
    formData.append('canned_response[content]', data.content);
    if (data.user_id) {
      formData.append('canned_response[user_id]', data.user_id);
    } else {
      formData.append('canned_response[user_id]', '');
    }
    if (data.files && data.files.length) {
      data.files.forEach(file => {
        formData.append('canned_response[files][]', file);
      });
    }
    return axios.patch(`${this.url}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new CannedResponse();
